var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95581 15.0818L22.0521 10.7051L21.801 21.4791L9.12797 25.8459L8.95581 15.0818ZM2.11195 17.745L1.95194 7.46877L7.6717 14.5523L8.02615 14.9905L8.03222 15.3872L8.18615 25.1121L2.10992 17.745H2.11195ZM2.15043 6.25513L14.9044 2.05103L21.8253 9.82267L8.60339 14.2409L2.15043 6.25513ZM15.192 1L1.54078 5.50156L1 5.68004L1.01418 6.62993L1.19444 18.0702L7.94513 26.2524L8.56085 27L9.14417 26.7997L22.7124 22.1256L22.9858 10.3938L23 9.77111L22.0987 8.75974L15.192 1Z",
    fill: "url(#paint0_linear_15882_62409)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02571 14.9906L1.95151 7.46879L2.11152 17.7451H2.10949L8.18572 25.1121L8.02571 14.9906ZM7.66319 23.6928L7.52842 15.1708L7.2825 14.8667L2.47404 8.91179L2.60877 17.5646L7.66319 23.6928ZM0.999565 5.68007L15.1916 1.00003L22.9996 9.77114L22.712 22.1256L9.14374 26.7997L8.56042 27L1.194 18.0703L0.999565 5.68007ZM0.696827 18.2533L0.494141 5.32035L1.38365 5.02678L15.3468 0.422363L22.4715 8.42711L23.5039 9.58556L23.4853 10.4052L23.2037 22.4851L8.39488 27.5855L0.696827 18.2533ZM9.46117 15.4399L9.61645 25.1486L21.3088 21.1198L21.5352 11.4049L9.46117 15.4399ZM8.95538 15.0818L9.12753 25.8459L21.8005 21.4792L22.0517 10.7052L8.95538 15.0818ZM14.904 2.05105L21.8248 9.8227L8.60295 14.241L2.15 6.25516L14.904 2.05105ZM2.99355 6.50356L14.7489 2.62866L20.9471 9.58884L8.7737 13.6567L2.99355 6.50356Z",
    fill: "url(#paint0_linear_15882_62409)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15882_62409",
    x1: 0.494141,
    y1: 14.9094,
    x2: 23.5039,
    y2: 14.9094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareGradient);
export default __webpack_public_path__ + "static/media/square_gradient.234630150149c5889eae962d613d4568.svg";
export { ForwardRef as ReactComponent };